import { errorMsg } from '../utils/errorMsg';
import React, { useState } from 'react';
import { Container, TextField, Button, Box, Grid, Alert, FormControlLabel, Switch } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import StartForm from '../components/StartForm';
import api from '../axios';

export default function CadastroProfessor() {
	const navigate = useNavigate();
	const [form, setForm] = useState({
		nome: '',
		email: '',
		senha: '',
		telefone_whatsapp: '',
		endereco: '',
		bairro: '',
		cep: '',
		data_nascimento: '',
		e_monitor: false,
	});
	const [loading, setLoading] = useState(false);
	const [success, setSuccess] = useState(false);
	const [successMsg, setSuccessMsg] = useState('');
	const [error, setError] = useState('');

	const handleChange = (e) => {
		setForm({ ...form, [e.target.name]: e.target.value });
	};

	const handleSubmit = async (e) => {
		e.preventDefault();
		setLoading(true);
		setError('');
		setSuccess(false);
		try {
			await api.post('/cadastro-professor/', form);
			setSuccess(true);
			setSuccessMsg('Cadastro realizado com sucesso! Você será redirecionado em instantes.');
			setForm({
				nome: '',
				email: '',
				senha: '',
				telefone_whatsapp: '',
				endereco: '',
				bairro: '',
				cep: '',
				data_nascimento: '',
				e_monitor: false,
			});
			setTimeout(() => {
				navigate('/login');
			}, 2000);
		} catch (err) {
			setError(errorMsg(err) || 'Erro ao cadastrar professor.');
		} finally {
			setLoading(false);
		}
	};

	return (
		<>
			<Header />
			<Container maxWidth="sm" sx={{ py: { xs: 2, md: 4 }, px: { xs: 1, md: 2 } }}>
				<StartForm
					title="Cadastro de Professor e Monitor"
					description="Preencha os dados para se cadastrar como professor ou monitor. Aguarde aprovação administrativa."
					onBack={() => navigate('/login')}
				>
					{success && (
						<Alert severity="success" sx={{ mb: 2 }}>
							{successMsg}
						</Alert>
					)}

					{error && (
						<Alert severity="error" sx={{ mb: 2 }}>
							{error}
						</Alert>
					)}

					<Box component="form" onSubmit={handleSubmit} sx={{ mt: 1 }}>
					<Grid container spacing={2}>
						<Grid item xs={12}>
							<TextField
								label="Nome Completo"
								name="nome"
								value={form.nome}
								onChange={handleChange}
								fullWidth
								required
							/>
						</Grid>
						
						<Grid item xs={12}>
							<TextField
								label="Email"
								name="email"
								type="email"
								value={form.email}
								onChange={handleChange}
								fullWidth
								required
							/>
						</Grid>
						
						<Grid item xs={12}>
							<TextField
								label="Senha"
								name="senha"
								type="password"
								value={form.senha}
								onChange={handleChange}
								fullWidth
								required
								inputProps={{ minLength: 6 }}
								helperText="Mínimo 6 caracteres"
							/>
						</Grid>
						
						<Grid item xs={12} sm={6}>
							<TextField
								label="Telefone/WhatsApp"
								name="telefone_whatsapp"
								value={form.telefone_whatsapp}
								onChange={handleChange}
								fullWidth
								placeholder="(00) 00000-0000"
							/>
						</Grid>
						
						<Grid item xs={12} sm={6}>
							<TextField
								label="Data de Nascimento"
								name="data_nascimento"
								type="date"
								value={form.data_nascimento}
								onChange={handleChange}
								fullWidth
								InputLabelProps={{
									shrink: true,
								}}
							/>
						</Grid>
						
						<Grid item xs={12}>
							<TextField
								label="Endereço"
								name="endereco"
								value={form.endereco}
								onChange={handleChange}
								fullWidth
								placeholder="Rua, número, complemento"
							/>
						</Grid>
						
						<Grid item xs={12} sm={6}>
							<TextField
								label="Bairro"
								name="bairro"
								value={form.bairro}
								onChange={handleChange}
								fullWidth
							/>
						</Grid>
						
						<Grid item xs={12} sm={6}>
							<TextField
								label="CEP"
								name="cep"
								value={form.cep}
								onChange={handleChange}
								fullWidth
								placeholder="00000-000"
							/>
						</Grid>
						
						<Grid item xs={12}>
							<FormControlLabel
								control={
									<Switch
										checked={form.e_monitor}
										onChange={(e) => setForm({ ...form, e_monitor: e.target.checked })}
										color="primary"
									/>
								}
								label="Desejo atuar como Monitor?"
							/>
						</Grid>
						
						<Grid item xs={12}>
							<Button
								type="submit"
								variant="contained"
								color="primary"
								aria-label="Cadastrar professor"
								fullWidth
								size="large"
								disabled={loading}
								sx={{ mt: 2 }}
							>
								{loading ? 'Cadastrando...' : 'Cadastrar Professor'}
							</Button>
						</Grid>
					</Grid>
				</Box>
				</StartForm>
			</Container>
			<Footer />
		</>
	);
}
